import CentroidsResource from '@/api/centroids'

export const centroidsResource = new CentroidsResource()
